import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../assets/styles';

const useStyles = makeStyles(() => ({
  button: {
    color: Colors.Blue1,
  },
}));

export default useStyles;